// Entry point for the build script in your package.json
import './application.css'
import "@hotwired/turbo"
import "./submit_shortcut"
import { Application } from "@hotwired/stimulus"

// Initialize Stimulus
const application = Application.start()

// Configure Stimulus development experience
if (import.meta.env.DEV) {
  application.debug = true
  window.Stimulus = application
}

// Eager load all controllers automatically
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })

for (const path in controllers) {
  const module = controllers[path]
  const name = path
    .replace(/^\.\.\/controllers\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/_/g, '-')          // Convert underscores to dashes
    .replace(/\//g, '--')        // Convert directory separators to double dashes

  application.register(name, module.default)
}
